<script>
  import { format } from 'svelte-i18n';
  import { useNavigate } from 'svelte-navigator';
  import { Button, Container, Row } from '@sveltestrap/sveltestrap';

  import { getNotificationsContext } from '@client/components/notifications';

  import { AssetsService } from '@client/services/assets';

  import { ImageEditForm } from './shared';

  const { addNotification } = getNotificationsContext();

  const navigate = useNavigate();

  export let data = {};
  export let mimeType = '';
  export let loading = false;
  export let invalidFilename = false;

  let deleteConfirmation = '';
  let showDeleteConfirmation = false;

  const notify = (text, type = 'success', autohide = 2500, position = 'top-right') => {
    addNotification({ text, type, autohide, position });
  };

  const confirmDeletion = async () => {
    loading = true;

    const response = await AssetsService.deleteImage(data);

    loading = false;

    if (response?.status >= 400) {
      notify($format('label.FAILURE.RULENAME_DELETE', { values: { rulename: data.rulename } }), 'error');

      return;
    }

    notify($format('label.SUCCESS.DELETE', { values: { type: data.rulename } }));

    navigate('/manage/assets/images');
  };

  const toggleConfirmation = () => (showDeleteConfirmation = !showDeleteConfirmation);
</script>

<div id="edit-image">
  <Container fluid>
    <Row class="pt-3">
      <ImageEditForm bind:data bind:mimeType bind:invalidFilename />
      <div class="section">
        <div class="delete-group">
          <h2>{$format('label.DELETE')}</h2>
          <p>{@html $format('label.DELETE_WARNING', { values: { type: $format('label.IMAGE').toLowerCase() } })}</p>
          {#if showDeleteConfirmation}
            <div class="delete-confirmation">
              <input
                type="text"
                bind:value={deleteConfirmation}
                placeholder={$format('label.PLACEHOLDER.DELETE', {
                  values: {
                    type: $format('label.IMAGE').toLowerCase(),
                    param: $format('label.FILENAME').toLowerCase()
                  }
                })}
              />
              <Button color="danger" disabled={deleteConfirmation !== data.filename} on:click={confirmDeletion}
                >{$format('label.DELETE')}</Button
              >
              <Button color="secondary" on:click={toggleConfirmation}>{$format('label.CANCEL')}</Button>
            </div>
            <small
              >{$format('label.DELETE_REQUIREMENT', {
                values: {
                  type: $format('label.IMAGE').toLowerCase(),
                  param: $format('label.FILENAME').toLowerCase()
                }
              })}</small
            >
          {:else}
            <Button color="danger" on:click={toggleConfirmation}>{$format('label.DELETE')}</Button>
          {/if}
        </div>
      </div>
    </Row>
  </Container>
</div>

<style lang="scss" src="./edit-image.scss"></style>
